import CtaLink from '@/atoms/Links/CTA/CtaLink';
import breakpoints from '@/theme/constants/breakpoints';
import styled from 'styled-components';

export const StyledViewAllBtn = styled(CtaLink)`
  width: 180px;
  display: block;
  text-align: center;
  margin: 10px auto 0;

  @media only screen and ${breakpoints.device.m} {
    float: right;
    margin-top: -50px;
  }
`;
